// Habit ID constants used across the application

// Be Secure habit ID - used to check if initiative task should be shown
// and to display correct programme name
export const BE_SECURE_HABIT_ID = '99e23d46-992b-4325-a7c9-e9500d3e8525';
